export const headerList = [
  {
    label: 'Symbol',
    orderField: 'symbol',
  },
  {
    label: 'Status',
    orderField: 'status',
  },
  {
    label: 'Type',
    orderField: 'type',
  },
  {
    label: 'Side',
    orderField: 'side',
  },
  {
    label: 'Qty.*',
    orderField: 'quantity',
  },

  {
    label: 'Price*',
    orderField: 'price',
  },
  {
    label: 'Avg. Fill Price',
    orderField: 'avg_fill_price',
  },
  {
    label: '# Filled',
    orderField: 'exec_quantity',
  },
  {
    label: 'Stop',
    orderField: 'stop',
  },
  {
    label: 'Last Fill Price',
    orderField: 'last_fill_price',
  },
  {
    label: 'Last Fill Qty.',
    orderField: 'last_fill_quantity',
  },
  {
    label: 'Remaining Qty.',
    orderField: 'remaining_quantity',
  },
  {
    label: 'Duration',
    orderField: 'duration',
  },
  {
    label: 'Created',
    orderField: 'create_date',
  },
  {
    label: 'Error',
    orderField: 'reason_description',
  },
];
